import React from 'react';
import ReactDOM from 'react-dom';

const isTextOverflow = element => {
    return element.clientWidth < element.scrollWidth;
};

const overflowDetectorFactory = ({ WrappedComponent }) => {
    return class OverflowDetector extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                textOverflow: false
            };
        }

        componentDidMount() {
            this.checkOverflow();
        }

        componentDidUpdate() {
            this.checkOverflow();
        }

        checkOverflow = () => {
            const element = ReactDOM.findDOMNode(this);
            const textOverflow = isTextOverflow(element);
            if (textOverflow !== this.state.textOverflow) {
                this.setState({ textOverflow });
            }
        };

        render() {
            return (
                <WrappedComponent
                    onMouseEnter={this.checkOverflow}
                    textOverflow={this.state.textOverflow}
                    {...this.props}
                />
            );
        }
    };
};
export default overflowDetectorFactory;
